module.exports = __webpack_public_path__ + "static/media/60gb.8a0920d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-satelital/60gb.png
// module id = 137
// module chunks = 0